import { createStore, combineReducers, applyMiddleware, compose } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
//import thunk from 'redux-thunk';
import createHistory from 'history/createBrowserHistory';
import { routerReducer, routerMiddleware } from 'react-router-redux';

import createSagaMiddleware from 'redux-saga';
import reducers from '../reducers';
import mySaga from '../sagas';

export const buildStore = () => {
  const sagaMiddleware = createSagaMiddleware();

  const history = createHistory();

  const switchStore = () => {
    let store;

    if (process.env.REACT_APP_ENV === 'production') {
      store = compose(
        applyMiddleware(sagaMiddleware),
        applyMiddleware(routerMiddleware(history)),
      );
    } else {
      store = composeWithDevTools(
        applyMiddleware(sagaMiddleware),
        applyMiddleware(routerMiddleware(history)),
      );
    }

    return store;
  };

  const store = createStore(
    combineReducers({
      router: routerReducer,
      ...reducers,
    }),
    switchStore(),
  );

  sagaMiddleware.run(mySaga);

  return store;
};



// WEBPACK FOOTER //
// ./src/store/configureStore.js